import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../utilities/TabUtilities";
import LSService from "../../../../utilities/localStorageService/LSService";

export default class PracownicyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {filterPracownik:false};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    componentDidMount(){
        if(Boolean(LSService.pobierzIdPracownikaDoFiltrowania())){
            this.setState({filterPracownik:LSService.pobierzIdPracownikaDoFiltrowania()})
            LSService.usunIdPracownikaDoFiltrowania()
        }
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointEdit onClick={()=>{this.props.handleEdytuj(row)}} titleContent={'Edytuj pracownika'} />
                <TopButtonPointRemove onClick={()=>{this.props.handleUsun(row)}} titleContent={'Usuń pracownika'} />
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idPr' isKey hidden={(this.state.filterPracownik===false)?true:false} thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={{type:'TextFilter', defaultValue:this.state.filterPracownik, condition:'eq'}}
                    >ID <span className={'fa fa-times'} onClick={()=>this.setState({filterPracownik:false})}
                              style={{color:'firebrick',cursor:'pointer'}} title={'Usuń filtrowanie po ID'}></span>
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField='imie'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Imie</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwisko'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Nazwisko</TableHeaderColumn>
                    <TableHeaderColumn dataField='email'
                                       thStyle={tabgrid.tg12} tdStyle={tabgrid.tg12}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Email</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPr'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/pracownicy/components/PracownicyTable.js